import React, { useEffect, useState } from 'react'
import { Alert, Form, notification } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useListSizes } from '../../../api/hooks/sizes/useListSizes';
import SizesTable from './SizesTable';
import { useCreateOrEditSize } from '../../../api/hooks/sizes/useCreateOrEditSize';
import SizesForm from './SizesForm';

function SizesManagement() {
    const { t } = useTranslation();
    const [getSizes, setSizes] = useState([]);
    const [editingSizes, setEditingSizes] = useState(null);
    const sizesQuery = useListSizes({});
    const queryClient = useQueryClient();
    const [form] = Form.useForm();

    useEffect(() => {
        if (sizesQuery.data) {
            setSizes(sizesQuery.data);
        }
    }, [sizesQuery.data]);

    const onErrorWrapper = (error) => {
        console.log(error);

    };

    const onSuccessWrapper = (response) => {
        if (response) {
            notification.success({
                message: response?.message, // Translated text
            });
        } else {
            notification.error({
                message: t("something_went_wrong"),
            });
        }
        queryClient
            .invalidateQueries({ queryKey: ["listSizes"] })
    };

    // listCategories
    const mutation = useCreateOrEditSize({
        onSuccess: onSuccessWrapper,
        onError: onErrorWrapper,
    });

    const onFinish = (values) => {
        if (editingSizes) {

            mutation.mutate({ payload: { ...values, id: editingSizes.size_id }, mode: "edit" });
        } else {
            mutation.mutate({ payload: values, mode: "create" });
        }
        setEditingSizes(null); // Reset after save
        form.resetFields();
    };

    const onEdit = (size) => {
        setEditingSizes(size);
    };
    return (
        <div>
            <h2 className="text-title text-lg md:text-2xl uppercase">
                {t("vd_ps_Sizes")}
            </h2>
            <div className="p-4 border border-gray-200 bg-white shadow-sm col-span-2 mt-5">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {/* Form takes 1/3 width */}
                    <div className="md:col-span-1">
                        <SizesForm form={form} onFinish={onFinish} editingSizes={editingSizes} setEditingSizes={setEditingSizes} />
                    </div>
                    {/* Table takes 2/3 width */}
                    <div className="md:col-span-2">
                        <SizesTable sizesData={getSizes} loading={sizesQuery.isLoading} onEdit={onEdit} />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default SizesManagement
